import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contact from '../views/Contact.vue'
import Articles from '../views/Articles.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import HowToArticle from '@/views/articles/HowToArticle.vue'
import EdiblesDosageArticle from '@/views/articles/EdiblesDosageArticle.vue'
import BlackMarketEdiblesArticle from '@/views/articles/BlackMarketEdiblesArticle.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/articles',
    name: 'Articles',
    component: Articles
  },
  {
    path: '/articles/how_to_use_our_calculator',
    component: HowToArticle
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
